export interface TutorialModel {
  _id: string;
  name: string;
  description: string;
  content: string;
  cover: string;
  status: boolean;
  apartment: string;
  metadata: {
    createdAt: Date;
    updatedAt: Date;
  };
}
